/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iletisim_S6_Label_VknInputs */

const tr_iletisim_s6_label_vkn = /** @type {(inputs: Iletisim_S6_Label_VknInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VKN`)
};

const en_iletisim_s6_label_vkn = /** @type {(inputs: Iletisim_S6_Label_VknInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VKN`)
};

const de_iletisim_s6_label_vkn = /** @type {(inputs: Iletisim_S6_Label_VknInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VKN`)
};

const ru_iletisim_s6_label_vkn = /** @type {(inputs: Iletisim_S6_Label_VknInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VKN`)
};

/**
* | output |
* | --- |
* | "VKN" |
*
* @param {Iletisim_S6_Label_VknInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iletisim_s6_label_vkn = /** @type {((inputs?: Iletisim_S6_Label_VknInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iletisim_S6_Label_VknInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iletisim_s6_label_vkn(inputs)
	if (locale === "de") return de_iletisim_s6_label_vkn(inputs)
	if (locale === "ru") return ru_iletisim_s6_label_vkn(inputs)
	return tr_iletisim_s6_label_vkn(inputs)
});